export type StartEndObject = {
    start   : string | Moment
    end     : string | Moment
}

export function convertToMomentRangeFromValue(value:StartEndObject):MomentRange {

    // NEW Experimental
    return momentRange(momentDate(value.start), momentDate(value.end))

    // OLD
    // @ts-ignore
    return moment.range(
        momentDate(value.start),
        momentDate(value.end)
    )

}

export function convertToMomentDateRangeFromValue(value:StartEndObject):StartEndObject {

    // used in condition... dumau govno no netu sil razbiratsya seichas

    const result = {
        start   : momentDate(value.start),
        end     : momentDate(value.end)
    }

    return result

}

export function momentRange(start: string | Moment, end : string | Moment) : MomentRange {

    // prikol v tom chto eto NE imenno start date !!! be carefull

    // @ts-ignore
    return moment.range( moment(start), moment(end) )

}

